import { observable, action } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import List from "app/stores/list"
import { message } from "antd"

export default class Store {
  @observable detailData = observable.map({})
  @observable submitData = {
    name: "",
    tel: "",
    address: "",
    printAddress: "",
    deputy: "",
    support: ""
  }

  @action createOrg = () => {
    return request.post(`${config.backend}/accounts/orgs`)
      .send(this.submitData)
      .checkToken()
      .commonDispose()
  }

  @action updateOrg = () => {
    return request.put(`${config.backend}/accounts/orgs/${this.detailData.get('id')}`)
      .send(this.detailData.toJS())
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.detailData.clear()
          this.list.getTableData()
            .then(
              res => {
                this.list.updateTableData(res)
                this.list.initPageIndex()
              }
            )
          return Promise.resolve(res)
        },
        err => {
          message.error(err)
          return Promise.reject(err)
        }
      )
  }

  @action getOrgDetail = (id) => {
    return request.get(`${config.backend}/accounts/orgs/${id}`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.detailData = observable.map({ ...res })
        }
      )
  }

  @action updateField = (e, field) => {
    this.submitData[field] = e.target.value
  }

  @action setDetailData = (data) => {
    this.detailData.merge(data)
  }

  static fromJS() {
    const store = new Store()
    store.list = new List(store, "accounts/orgs")
    return store
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/preview/organization.js